import $ from 'jquery';
import Api from './Api';
import {store} from '../store/index';

function getOrgId() {
  return store.getters['user/getOrgContext'] || store.getters['user/getOrgId'];
}

export default {
  async getOrgCustomRoles() {
    return new Api(true).get('/admin/api/v1/orgs/' + getOrgId() + '/roles');
  },
  async getOrganizations() {
    return new Api().get('/admin/api/v1/orgs');
  },
  async getCcoOrg() {
    return new Api().get('/admin/api/v1/orgs/cco');
  },
  async getUsers(deleted) {
    if (!getOrgId()) {
      return;
    }
    return new Api().get(`/admin/api/v1/orgs/${getOrgId()}/users?deleted=${deleted}`);
  },
  async getCcoUsers() {
    return new Api().get('/admin/api/v1/cco_users');
  },
  async getUserPrivileges() {
    const api = new Api(undefined, {
      orgId: getOrgId()
    });
    return api.get('/admin/api/v1/privileges/current');
  },
  async changePassword(userId, patch) {
    return new Api().patch('/admin/api/v1/orgs/' + getOrgId() + '/users/' + userId, patch);
  },
  async addOrUpdateUser(user) {
    return new Api().put('/admin/api/v1/orgs/' + getOrgId() + '/users' , user);
  },
  async deleteUser(userId) {
    return new Api().patch('/admin/api/v1/orgs/' + getOrgId() + '/users/' + userId , {deleted: true});
  },
 async logActivity(activity) {
    if (!getOrgId()) {
      return;
    }
    return new Api().post('/admin/api/v1/orgs/' + getOrgId() + '/log_activity', activity)
  },
  async getToken(userId) {
    return new Api().get('/admin/api/v1/orgs/' + getOrgId() + '/users/' + userId + '/token')
  },
  async unDeleteUser(userId) {
    return new Api().patch('/admin/api/v1/orgs/' + getOrgId() + '/users/' + userId , {deleted: false})
  },
  async unDeleteUsers(userIds) {
    return new Api().patch('/admin/api/v1/orgs/' + getOrgId() + '/users' , {userIds, deleted: false})
  },
  async patchMultiple (patchList) {
    return new Api().patch(`/admin/api/v1/orgs/${getOrgId()}/users`, patchList)
  }
}
